import DraftOrderConfirmPage from '../../components/pages/draft_orders/DraftOrderConfirmPage.vue'
export default {
  components: { DraftOrderConfirmPage }
}
